var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-tw",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h496.06v496.06H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(1.0321)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M0 0h744.09v496.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08399c",
    d: "M0 0h373.69v248.03H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M273.324 173.001l-45.86-9.43 9.77 45.79-35.01-31.09-14.44 44.54-14.77-44.44-34.77 31.36 9.43-45.86-45.79 9.76 31.09-35-44.539-14.44 44.43-14.77-31.35-34.773 45.86 9.427-9.76-45.792 35 31.095 14.44-44.54 14.77 44.432 34.77-31.354-9.43 45.863 45.79-9.767-31.09 35.01 44.54 14.43-44.43 14.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005387",
    d: "M231.045 169.48l-14.47 7.684-14.117 8.34-16.391-.564-16.392.191-13.914-8.663-14.298-8.017-7.706-14.442-8.362-14.069.556-16.347-.182-16.358 8.686-13.874 8.039-14.258 14.47-7.687 14.117-8.34 16.391.562 16.402-.186 13.914 8.66 14.288 8.018 7.706 14.438 8.362 14.069-.556 16.347.182 16.358-8.686 13.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.028 124.291c0 27.754-22.499 50.253-50.253 50.253s-50.253-22.499-50.253-50.253 22.5-50.253 50.253-50.253 50.253 22.5 50.253 50.253z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.2a1ca9e089194fe495fca8ff2f0509bb.svg";
export { ForwardRef as ReactComponent };